<template>
    <div class="row">
        <div class="col col-12" style="padding-top:20px;padding-bottom:20px;">
            <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" v-model="BlockProps[propertyname]" :id="uid">
                <label class="form-check-label" :for="uid">{{prompt}}</label>
            </div>

        </div>
        <hr style="margin-top: 10px; margin-bottom:5px;" />
    </div>
</template>

<style>
</style>




<script>
    import { v4 as uuidv4 } from 'uuid';

    export default {
        name: 'propertytogglededitor',
        emits: [],
        components: { },
        props: [
            "blockprops",
            "propertyname",
            "prompt"
        ],
        data() {
            return {    
                uid: ''
            };
        },
        methods:
        {      
          
        },
        computed:
        {
            BlockProps: function(){
                return this.blockprops;
            }
        },
        beforeMount: function () {

        },
        mounted: function () {
            this.uid = uuidv4();
        },
        beforeUnmount: function () {

        }
    }
</script>
